export default {
  common: {
    clearAll: 'Wyczyść wszystko',
    restart: 'Uruchom ponownie'
  },
  download: {
    bodyText: 'Kliknij poniższy link, aby pobrać %{products}',
    bothProducts: 'PlayBase i/lub Nexus',
    bodyTextFromAcceptInvitation:
      'Proces zajmie trochę czasu. W międzyczasie możesz kontynuować korzystanie z Metrica Sports jak zwykle.',
    bodyTextFromDeclineInvitation:
      'Odrzuciłeś zaproszenie! Kliknij poniższy link, aby pobrać %{products}',
    bodyTextFromTrial:
      'Witaj w Twoim Okresie Próbny! Sprawdź swój zarejestrowany adres email w poszukiwaniu linku weryfikacyjnego (sprawdź folder ze spamem).',
    bodyTitle: 'Pobierz',
    bodyTitleFromAcceptInvitation: 'Przełączamy Twoje konto',
    bodyTitleFromDeclineInvitation: 'Zaproszenie Odrzucone',
    bodyTitleFromTrial: 'Rejestracja zakończona',
    play2: {
      description:
        'Metrica PlayBase to intuicyjne narzędzie do analizy zaprojektowane dla trenerów amatorów i prosumenckich, małych klubów oraz niezależnych analityków. Upraszcza proces oceny wydajności, czyniąc go dostępnym dla każdego.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'Metrica Nexus jest dostosowany dla elitarnych analityków i trenerów poszukujących kompleksowych informacji o wynikach. Dzięki zaawansowanym narzędziom w zasięgu ręki, możesz ulepszyć strategie zespołu i osiągnąć sukces.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      'Dziękujemy za rejestrację w Metrica Sports! Aby rozpocząć okres próbny, pobierz %{products}.'
  },
  error: {
    restart: 'Wygląda na to, że próbujesz dostać się do obszaru, nad którym wciąż pracujemy...',
    tryAgainMsg:
      'Prosimy spróbować ponownie, a jeśli błąd nadal występuje, skontaktuj się z zespołem pomocy technicznej Metrica Sports'
  },
  verifyEmail: {
    generateLink: 'Wygeneruj nowy link, logując się do Play',
    readyToLogin: 'Jesteś gotowy, aby zalogować się do Play',
    successfully: 'Adres e-mail został zweryfikowany pomyślnie',
    unsuccessfully: 'Błąd podczas weryfikacji wiadomości e-mail, nieprawidłowy symbol'
  }
}
